import { useEffect, useRef, useState } from 'react';

const useTimer = (initialSeconds: number) => {
  const [seconds, setSeconds] = useState<number>(initialSeconds);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const clearTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  const resetTimer = () => {
    clearTimer();
    setSeconds(initialSeconds);
    intervalRef.current = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds <= 1) {
          clearTimer();
          return 0;
        }
        return prevSeconds - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    resetTimer();

    return () => {
      clearTimer();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialSeconds]);

  return { seconds, resetTimer };
};

export default useTimer;
